<div class="form-group">
    <label class="input-label">Order nr in grid:</label>
    <input type="number"
           name="fieldOptions.label"
           value="{{fieldOptions.ordernr}}"
           [(ngModel)]="fieldOptions.ordernr"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>